import React, { useCallback, useEffect, useState } from 'react';
import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
  Box
} from '@mui/material';
import { FormProvider, SelectTag, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

export const RefundRegisterReport = () => {
  const { pathname } = useLocation();
  const [userdata, setUserData] = useState([]);
  
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required('From date is required'),
        to_date: Yup.string().required('To date is required'),
        user: Yup.string().required('User is required')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
      user: ''
    },
    mode: 'all'
  });

  const { watch } = methods;

  const getUserList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);

  useEffect(() => {
    getUserList();
  }, [getUserList]);

  const handleViewReport = () => {
    const params = {
      user: watch('user'),
      from_date: watch('from_date'),
      to_date: watch('to_date')
    };
    window.open(
      `/print${pathname}?refId=${JSON.stringify(params)}`,
      '_blank'
    );
  };

  // Create unique list of usernames from createdBy field
  const getUniqueUserList = () => {
    // Start with "All" option
    const userOptions = [{ name: 'All', _id: 'all' }];
    
    // Add unique usernames from the response data
    // Since we don't have the response data here, we'll use the userdata from API
    // But in your case, you might want to fetch unique createdBy values from the backend
    const uniqueNames = new Set();
    
    userdata.forEach(user => {
      // Combine first_name and last_name to match createdBy format
      const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
      if (fullName && !uniqueNames.has(fullName)) {
        uniqueNames.add(fullName);
        userOptions.push({
          name: fullName,
          _id: fullName // Use the full name as the value to match createdBy
        });
      }
    });
    
    return userOptions;
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Refund Register Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('user')}
                  onClick={handleViewReport}
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>User</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="user"
                      menus={getUniqueUserList()}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};

export default RefundRegisterReport;